
































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import ItemModel from '@/models/ItemModel';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';
import {deleteUser, fetchUsers, saveUser} from "@/repositories/api/UserApi";

import BaseLayout from '@/layouts/BaseLayout.vue';
import Overlay from '@/models/Overlay';
import Breadcrumb from "@/models/Breadcrumb";
import BaseListView from "@/views/BaseListView.vue";
import User from "@/models/User";

@Component({
    components: {
        BaseLayout,
    }
})
export default class UserListView extends BaseListView {
  protected pageTitle = 'Utilisateur';
  protected pageSubTitle = 'Liste';
  protected breadcrumbs: Breadcrumb[] = [
      {
          text: 'Accueil',
          disabled: false,
          icon: '',
          href: '/',
      },
      {
          text: 'Administration',
          disabled: false,
          icon: '',
          href: '/administration/utilisateurs',
      },
      {
          text: 'Utilisateurs',
          disabled: false,
          icon: '',
          href: '/administration/utilisateurs',
      },
      {
          text: 'Liste',
          disabled: true,
          icon: '',
          href: '/administration/utilisateurs/liste',
      },
  ];
  protected fetchItems: Function = fetchUsers;
  protected newItemLabel = 'Nouvel utilisateur';
  protected selectedDeleteActionLabel = 'Supprimer l\'(es) utilisateur(s)';
  protected headers = [
    {
      text: '#',
      align: 'left',
      sortable: true,
      value: 'id',
    },
    {text: 'Nom complet', value: 'fullName'},
    {text: 'Roles', value: 'roles'},
    {text: 'Email', value: 'email'},
    {text: 'Actions', value: 'action', sortable: false, align: 'right'},
  ];
  protected viewLabel = 'En attente';
  protected deleteDialog = false;
  protected loading = false;
  protected selectedDeleteDialog = false;
  protected overlay = new Overlay();
  protected items: {id: number, name: string}[] = [];
  protected itemModels: ItemModel[] = [];
  protected itemDeleter: Function = deleteUser;
  protected deleteIndex: number = -1;
  protected alert: Alert = new Alert();
  protected selected: {id: number, name: string}[] = [];

  newItemAction(){
      // @ts-ignore
      this.dialog = true;
  }

  roleMappings = [
      {name: 'ROLE_USER', label: 'Utilisateur', textColor: 'white', color: 'grey'},
      {name: 'ROLE_ADMIN_FAUNA', label: 'Administrateur Faune', textColor: 'white', color: 'green'},
      {name: 'ROLE_ADMIN_FLORA', label: 'Administrateur Flore', textColor: 'white', color: 'green'},
      {name: 'ROLE_ADMIN', label: 'Administrateur', textColor: 'white', color: 'blue'},
      {name: 'ROLE_SUPER_ADMIN', label: 'Super Administrateur', textColor: 'white', color: 'indigo'},
      {name: 'ROLE_DEVELOPER', label: 'Développeur', textColor: 'white', color: 'deep-purple'},
  ];

  async deleteItem(item: User): Promise<boolean> {
    let deleted = false;
    this.overlay.text = 'Suppression de l\'élément ' + item.fullName + ' en cours...';
    this.overlay.show = true;

    try {
      const response: { status: string, message: string } = await this.itemDeleter(item.id);

      if(response.status == 'success'){
        deleted = true;
      }

      this.alert = new Alert(response.message, response.status, true);
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
    }

    this.overlay.show = false;

    return deleted;
  }

  async save() {
      this.overlay.text = `Enregistrement de l'utilsateur en cours...`;
      this.overlay.show = true;
      try {
          // @ts-ignore
          await saveUser(this.editedItem);

          // @ts-ignore
          if (this.editedIndex > -1) {
              // @ts-ignore
              Object.assign(this.items[this.editedIndex], this.editedItem);
          } else {
              // @ts-ignore
              this.items.push(this.editedItem);
          }
      } catch (e) {

      }

      this.overlay.show = false;

      // @ts-ignore
      this.close();
  }


    async processDeleteItem() {
    this.deleteDialog = false;
    if (await this.deleteItem(this.items[this.deleteIndex])) {
      this.items.splice(this.deleteIndex, 1);
    }
  }

  async processSelectedDeleteItem() {
    this.selectedDeleteDialog = false;
    for (const item of this.selected) {
      if (await this.deleteItem(item)) {
        this.selected.splice(this.selected.indexOf(item), 1);
        this.items.splice(this.items.indexOf(item), 1);
      }
    }
  }
}
